<div class="count">
  <div class="newDeck">
    <h2>Editar Deck</h2>

    <input type="text" placeholder="Nome do Deck" [(ngModel)]="deckName" />

    <!-- Select dinâmico -->
    <select name="folder" [(ngModel)]="selectedFolderId">
      <option value="">Selecione uma Pasta</option>
      @for (folder of folders; track folder.idPasta) {
        <option [value]="folder.idPasta">{{ folder.nome }}</option>
      }
    </select>

    <h3>Flashcards</h3>

    <div class="flashcards">
      @for (card of cards; track $index) {
        <div class="card-form">
          <textarea placeholder="Pergunta" [(ngModel)]="card.question"></textarea>
          <textarea placeholder="Resposta" [(ngModel)]="card.answer"></textarea>

          <button (click)="removeCard($index)"><ion-icon name="close"></ion-icon></button>
        </div>
      }
    </div>

    <div class="buttons">
      <div class="">
        <button (click)="addCard()">Adicionar Card</button>
        <button class="save" (click)="save()">Atualizar Deck</button>
      </div>
    </div>
  </div>
</div>